
interface ElementPosition {
  element: string;
  top: number;
  left: number;
  width: number;
  height: number;
}

/**
 * Get a unique color for each element type
 */
export function getColorForElement(element: string): string {
  const colors = {
    'document': 'rgba(255, 0, 0, 0.7)',
    'body': 'rgba(0, 255, 0, 0.7)',
    '#root': 'rgba(0, 0, 255, 0.7)',
    '.app-shell': 'rgba(255, 255, 0, 0.7)',
    '.app-shell-content': 'rgba(255, 0, 255, 0.7)',
    'first-button': 'rgba(0, 255, 255, 0.7)'
  };
  
  return colors[element as keyof typeof colors] || 'rgba(128, 128, 128, 0.7)';
}

/**
 * Calculate misalignments between elements
 */
export function calculateMisalignments(positions: ElementPosition[]): string[] {
  const misalignments: string[] = [];
  
  // Look for the document and #root elements specifically
  const documentPos = positions.find(p => p.element === 'document');
  const rootPos = positions.find(p => p.element === '#root');
  
  if (documentPos && rootPos) {
    const topDiff = rootPos.top - documentPos.top;
    if (topDiff !== 0) {
      misalignments.push(`#root is offset from document by ${topDiff}px vertically`);
    }
  }
  
  // Check relative positions of all elements
  for (let i = 0; i < positions.length; i++) {
    for (let j = i + 1; j < positions.length; j++) {
      const elem1 = positions[i];
      const elem2 = positions[j];
      
      // Only report significant misalignments (more than 5px)
      const leftDiff = Math.abs(elem1.left - elem2.left);
      const topDiff = Math.abs(elem1.top - elem2.top);
      
      if (leftDiff > 5) {
        misalignments.push(`${elem1.element} and ${elem2.element} are misaligned horizontally by ${leftDiff}px`);
      }
      
      if (topDiff > 5 && elem1.element !== elem2.element) {
        misalignments.push(`${elem1.element} and ${elem2.element} are misaligned vertically by ${topDiff}px`);
      }
    }
  }
  
  return misalignments;
}
